import { render, staticRenderFns } from "./SaleEditRowDiscount.vue?vue&type=template&id=606b36f2&scoped=true"
import script from "./SaleEditRowDiscount.vue?vue&type=script&lang=ts"
export * from "./SaleEditRowDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b36f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606b36f2')) {
      api.createRecord('606b36f2', component.options)
    } else {
      api.reload('606b36f2', component.options)
    }
    module.hot.accept("./SaleEditRowDiscount.vue?vue&type=template&id=606b36f2&scoped=true", function () {
      api.rerender('606b36f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditRowDiscount.vue"
export default component.exports